import React from 'react'
import type {OpiHourlySummary} from './_requests'

type Props = {
  rows: OpiHourlySummary[]
  totals: OpiHourlySummary
}

export const CallsSummaryTable: React.FC<Props> = ({rows, totals}) => (
  <div className='opi-table-card opi-summary-table'>
    <div className='opi-table-card__header'>
      <h3>Calls Summary by Hour</h3>
    </div>
    <div className='opi-table-card__scroll' style={{maxHeight: 420}}>
      <table>
        <thead>
          <tr>
            <th>Hour</th>
            <th>Total Calls</th>
            <th>Success %</th>
            <th>Abandoned %</th>
            <th>Connected</th>
            <th>Abandoned</th>
            <th>Backstop</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={7} className='opi-empty'>
                No hourly data for the selected filters.
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.hour}>
                <td style={{fontWeight: 500}}>{row.hourLabel}</td>
                <td style={{color: '#565d6d'}}>{row.totalCalls}</td>
                <td>{row.successPercent}%</td>
                <td>{row.abandonedPercent}%</td>
                <td>{row.connected}</td>
                <td>{row.abandoned}</td>
                <td>{row.backstop}</td>
              </tr>
            ))
          )}
          {rows.length > 0 && (
            <tr className='opi-summary-total'>
              <td>{totals.hourLabel}</td>
              <td style={{color: '#565d6d'}}>{totals.totalCalls}</td>
              <td>{totals.successPercent}%</td>
              <td>{totals.abandonedPercent}%</td>
              <td>{totals.connected}</td>
              <td>{totals.abandoned}</td>
              <td>{totals.backstop}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)
